import dayjs from 'dayjs';
import {
  toParticipantsArray,
  toParticipantOption
} from '../../../../utils/reviewParticipants';

export const setRatingShowInfo = ({
  reviewData,
  setQuestionnaireType,
  form
}) => {
  const isPensionerAuthor = reviewData.author.role === 'users:PENSIONER';
  setQuestionnaireType(isPensionerAuthor ? 'users:PENSIONER' : 'users:OWNER');

  const receiverOptions = toParticipantsArray(reviewData?.receiver?.id).map(
    toParticipantOption
  );

  form.setFieldsValue({
    ...reviewData,
    questionnaire_type: isPensionerAuthor ? 'users:PENSIONER' : 'users:OWNER',
    author: { id: toParticipantOption(reviewData.author.id) },
    receiver: { id: isPensionerAuthor ? receiverOptions[0] : receiverOptions },
    date: dayjs(reviewData.date)
  });
};
